import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import numeral from "numeral";

import { withRedux } from "../hoc";
import { BackgroundImage, Image } from "../components";

import iconPlus from "../pages/Booking/svg/plus.svg";
import iconMinus from "../pages/Booking/svg/minus.svg";

const mapStateToProps = (state) => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

@withRedux(mapStateToProps)
class FoodItem extends PureComponent {
  static propTypes = {
    defaultTitle: PropTypes.string,
    defaultShostDes: PropTypes.string,
    defaultDescription: PropTypes.string,
  };
  static defaultProps = {
    defaultTitle: "",
    defaultShostDes: "",
    defaultDescription: "",
  };

  state = {
    value: 0,
  };

  addValue = () => {
    const { value } = this.state;
    const { data, onChangeAddValue } = this.props;
    onChangeAddValue({ ...data, value: value + 1 });
    this.setState({
      value: value + 1,
    });
  };

  removeValue = () => {
    const { value } = this.state;
    const { data, onChangeRemoveValue } = this.props;
    if (value > 0) {
      onChangeRemoveValue({ ...data, value });
      // onChangeRemoveValue({ ...data, value: value - 1 });
      this.setState({
        value: value - 1,
      });
    }
  };

  render() {
    const { value } = this.state;
    const { t, data, onClick } = this.props;
    const title = _.get(data, "title");
    const shostDescription = _.get(data, "short_description");
    const image = _.get(data, ["image", "full_file_path"], "");

    const price = _.toNumber(_.get(data, "price"));
    return (
      <div className="row mb-3">
        <div
          className="col-md-8 col-md-8 px-md-0 py-3"
          onClick={() => onClick(data)}
        >
          <div className="content-block">
            <div className="col-md-4 col-5 align-center">
              <div className="image-block">
                <BackgroundImage image={image} />
              </div>
            </div>
            <div className="col-md-8 col-7 px-0 pl-0">
              <div className="description-block">
                <p className="title">{t(title)}</p>
                <p className="price">
                  {numeral(_.get(data, "price")).format("0,0")} {t("THB")}
                </p>
                <p className="des">{t(shostDescription)}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 px-md-0">
          <div className="content-block">
            <div className="col-md-7 col-5 padding-none control-bar amount-block">
              <div
                className="icon-block amount-minus"
                onClick={() => this.removeValue()}
              >
                <Image src={iconMinus} alt="" />
              </div>
              <div className="icon-block... amount-value">{value}</div>
              <div
                className="icon-block amount-plus"
                onClick={() => this.addValue()}
              >
                <Image src={iconPlus} alt="" />
              </div>
            </div>
            <div className="col-md-5 col-7 price-block align-center padding-none">
              <p className="price">
                {numeral(price * value).format("0,0")} {t("THB")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FoodItem;



// WEBPACK FOOTER //
// ./src/components/FoodItem.js